import { render } from "./gallerypage.vue?vue&type=template&id=52c02f9c&scoped=true"
import script from "./gallerypage.vue?vue&type=script&lang=js"
export * from "./gallerypage.vue?vue&type=script&lang=js"

import "./gallerypage.vue?vue&type=style&index=0&id=52c02f9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c02f9c"]])

export default __exports__